import AppStoreButton from './AppStoreButton';
import PhoneMockup from './PhoneMockup';
import Reveal from './Reveal';
import screen1 from '../assets/images/screen_1.PNG';
import screen2 from '../assets/images/screen_2.PNG';
import screen3 from '../assets/images/screen_3.PNG';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero__glow" aria-hidden="true" />
      <div className="hero__grid" aria-hidden="true" />

      <div className="container hero__inner">
        <Reveal as="h1" className="hero__title" delay={60}>
          Your friends already know what you should{' '}
          <span className="hero__accent">watch next.</span>
        </Reveal>

        <Reveal as="p" className="hero__subtitle" delay={120}>
          Discover movies and shows through recommendations from the people you
          trust or ask Peekster, your personal AI, for a pick that matches your
          exact mood.
        </Reveal>

        <Reveal className="hero__actions" delay={180}>
          <AppStoreButton variant="primary" />
        </Reveal>

        <Reveal className="hero__phones" delay={240}>
          <div className="hero__phone hero__phone--side hero__phone--left">
            <PhoneMockup src={screen3} alt="Peek movie detail page for The Woman King with cast and ratings" />
          </div>
          <div className="hero__phone hero__phone--main">
            <PhoneMockup src={screen1} alt="Peek Discover screen showing movies and shows recommended by friends" />
          </div>
          <div className="hero__phone hero__phone--side hero__phone--right">
            <PhoneMockup src={screen2} alt="Peek social feed showing friends' video reactions to shows" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
